import { render, staticRenderFns } from "./CennikCard.vue?vue&type=template&id=608d4cdf&scoped=true&"
import script from "./CennikCard.vue?vue&type=script&lang=js&"
export * from "./CennikCard.vue?vue&type=script&lang=js&"
import style0 from "./CennikCard.vue?vue&type=style&index=0&id=608d4cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d4cdf",
  null
  
)

export default component.exports